import { createAction } from '@reduxjs/toolkit';

export const textUpdateRequest = createAction('emailsText/updateRequest');
export const textUpdateError = createAction('emailsText/updateError');
export const textUpdateStore = createAction('emailsText/updateStore');

export const textStore = createAction('emailsText/store');
export const textClear = createAction('emailsText/clear');

export const textUpdateId = createAction('emailsText/updateId');
export const textUpdateIsActive = createAction('emailsText/updateIsActive');

export const textUpdateContent = createAction('emailsText/updateContent');
